//
//
//
//
//
//
//
//

import { isExternal } from "@/utils/validate";
export default {
  props: {
    to: {
      type: String,
      required: true
    },
    isLink: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    linkProps: function linkProps(url, isLink) {
      if (!isLink) {
        return {
          is: "div"
        };
      }
      if (isExternal(url)) {
        return {
          is: "a",
          href: url,
          target: "_blank",
          rel: "noopener"
        };
      }
      return {
        is: "router-link",
        to: url
      };
    }
  }
};